import {
  TERMINAL_BACKOFF_BASE_MS,
  TERMINAL_BACKOFF_FACTOR,
  TERMINAL_BACKOFF_MAX_MS,
} from '../../../utils/constants/terminalConstants';

export function nextBackoffMs(attempt: number): number {
  const exponent = Math.max(0, attempt);
  return Math.min(
    TERMINAL_BACKOFF_MAX_MS,
    TERMINAL_BACKOFF_BASE_MS * TERMINAL_BACKOFF_FACTOR ** exponent,
  );
}
